export default __webpack_public_path__ + "static/pragicts-secops-services-msiemaas-6008556f45377cb90a68d32e7b2e23db.jpg";